import { render, staticRenderFns } from "./AcceptanceForm.vue?vue&type=template&id=235ef256"
import script from "./AcceptanceForm.vue?vue&type=script&lang=js"
export * from "./AcceptanceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports